import { render, staticRenderFns } from "./fccVersionamento.vue?vue&type=template&id=4c674092"
import script from "./fccVersionamento.vue?vue&type=script&lang=js"
export * from "./fccVersionamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports